import { BreadcrumbItem, Breadcrumbs } from '@components/Breadcrumbs'
import { Image } from '@gassan-ui'
import { cn } from '@lib/cn'
import { imgix } from '@lib/imigx'
import { FC } from 'react'

type GalleryProps = {
  image: string
  breadcrumbItems: BreadcrumbItem[]
}

const ProductImage: FC<GalleryProps> = ({ image, breadcrumbItems }) => {
  return (
    <>
      <section
        className={cn(
          'relative w-full bg-shade-50',
          'before:block before:pt-[107.5%] before:content-[""]',
          'sm:before:pt-[74%]',
          'lg:before:pt-[70%]',
        )}
      >
        <div
          className={cn(
            'absolute top-0 z-[5] flex w-full justify-between px-4 pt-4',
            'sm:px-8 sm:pt-6',
            'lg:px-10',
          )}
        >
          <Breadcrumbs items={breadcrumbItems} />
        </div>
        <Image
          sources={[
            imgix(image, { width: 768 }),
            imgix(image, { width: 1024 }),
            imgix(image, { width: 1024 }),
            imgix(image, { width: 1200 }),
          ]}
          placeholderSrc={imgix(image, { width: 50 })}
          objectFit="contain"
          loading="lazy"
          className={cn(
            'absolute left-0 top-0 h-full w-full bg-shade-50 opacity-100 transition-opacity duration-300',
            '[&>img]:object-[top_center]',
            'sm:[&>img]:object-center',
          )}
        />
      </section>
    </>
  )
}

export default ProductImage
